/**
 * Maps KAI write-tool proposals to local product-draft patches (unsaved Add Product flow).
 */

export function kaiActionToDraftPatch(tool, args = {}) {
  if (!tool || !args) return null;

  switch (tool) {
    case "create_product":
    case "update_product": {
      const patch = {};
      const info = {};
      if (args.name) info.name = args.name;
      if (args.summary) info.summary = args.summary;
      if (args.description) info.description = args.description;
      if (Object.keys(info).length) patch.productInformation = info;
      if (args.brandName) patch.brand = { name: args.brandName };
      if (args.categoryName) {
        patch._categoryNameHint = args.categoryName;
      }
      if (args.price != null) patch.priceInDefaultCurrency = Number(args.price);
      if (args.stock != null) {
        patch.quantityAvailable = Number(args.stock);
        patch.isProductInventoryUnlimited = false;
      }
      return Object.keys(patch).length ? patch : null;
    }
    case "set_price":
      return args.price != null ? { priceInDefaultCurrency: Number(args.price) } : null;
    case "set_stock":
      if (args.unlimited === true) return { isProductInventoryUnlimited: true };
      return args.stock != null
        ? { quantityAvailable: Number(args.stock), isProductInventoryUnlimited: false }
        : null;
    default:
      return null;
  }
}

export function kaiActionToGeneralFormFields(tool, args = {}) {
  const patch = kaiActionToDraftPatch(tool, args);
  if (!patch) return null;
  const form = {};
  if (patch.productInformation?.name) form.name = patch.productInformation.name;
  if (patch.productInformation?.summary) form.summary = patch.productInformation.summary;
  if (patch.productInformation?.description) form.description = patch.productInformation.description;
  if (patch.brand?.name) form.brand = patch.brand.name;
  if (args.productTypeName) form.type = args.productTypeName;
  if (args.productConditionName) form.condition = args.productConditionName;
  return Object.keys(form).length ? form : null;
}

export function isDraftApplicableWrite(tool) {
  return ["create_product", "update_product", "set_price", "set_stock"].includes(tool);
}
